'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        isScrolled ? 'bg-background/80 backdrop-blur-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex justify-start lg:flex-1">
            <Link href="/" className="text-xl font-semibold text-white">
              Osaze Okunbo
            </Link>
          </div>
          <nav className="hidden md:flex space-x-8">
            <Link href="/#projects" className="text-base font-medium text-text-secondary hover:text-white transition-colors">
              Projects
            </Link>
            <Link href="/#process" className="text-base font-medium text-text-secondary hover:text-white transition-colors">
              Process
            </Link>
            <Link href="/#contact" className="text-base font-medium text-text-secondary hover:text-white transition-colors">
              Contact
            </Link>
          </nav>
          <div className="flex items-center justify-end lg:flex-1">
            <Link
              href="/resume"
              className="inline-flex items-center px-4 py-2 text-sm font-semibold text-white bg-brand-accent rounded-md hover:bg-brand-accent-hover transition-colors"
            >
              Resume
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
